<!-- apps/web/src/components/icons/IconMenu.vue -->
<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
       stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M3 6h18M3 12h18M3 18h18"/>
  </svg>
</template>
